import script from "./ProjectsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectsList.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectsList.vue?vue&type=style&index=0&id=1665c741&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1665c741"]])

export default __exports__
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTd});
